import { format, parseISO } from "date-fns";

import { translationService } from "../translation/TranslationService";

export interface IDate {
  currentDate: Date;
  formatDate: (date: Date | string) => string;
  dateToUTC: (date: Date) => Date;
}

export class DateService implements IDate {
  currentDate: Date = new Date();

  formatDateTime = (date: string | Date): string => {
    return format(new Date(date), "MM/dd/yyyy HH:mm:ss");
  }

  formatDate = (date: string | Date | undefined, formatString: string = "P"): string => {
    if (!date) return "";

    const dateObject = typeof date === "string" ? new Date(date) : date;

    const formattedDate = format(dateObject, formatString, {
      locale: translationService.locale,
    });

    return formattedDate;
  };

  dateToUTC = (date: Date): Date => {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  };

  getDateBasedOnBMFormat = (date: string, formatString: string): Date | null => {
    if (!date) return null;
    if (formatString === "yyyyMMdd") {
      const replacedDate = date.replace(/(\d{4})(\d{2})(\d{2})/g, "$1/$2/$3");
      return new Date(replacedDate);
    }
    return new Date(date);
  };

  getYearFromDate = (date: string): number | string => {
    return new Date(date).getFullYear();
  };

  dateIsInInterval = (
    date: Date | string,
    startIntervalDate: Date | string,
    endIntervalDate: Date | string
  ): boolean => {
    let dateToCheckObject = date;
    let startIntervalDateObject = startIntervalDate;
    let endIntervalDateObject = endIntervalDate;

    if (typeof date === "string") {
      dateToCheckObject = new Date(date);
    }

    if (typeof startIntervalDate === "string") {
      startIntervalDateObject = new Date(startIntervalDate);
    }

    if (typeof endIntervalDate === "string") {
      endIntervalDateObject = new Date(endIntervalDate);
    }

    return (
      startIntervalDateObject <= dateToCheckObject && dateToCheckObject <= endIntervalDateObject
    );
  };

  getDateFromString = (date: string | Date): Date => {
    const fullDate = typeof date === "string" ? parseISO(date) : parseISO(date.toISOString());
    return this.dateToUTC(fullDate);
  };
}

export const dateService = new DateService();
export default dateService;
